<template>
  <div>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane :label="$l('tabs_tab_sample') || '样品资料'" name="sample">
        <tab-sample ref="tabsample" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tabs_tab_elements') || '素材资料'"
        name="design"
        lazy
      >
        <tab-design ref="tabdesign" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tabs_tab_research') || '市场情报'"
        name="research"
        lazy
      >
        <tab-research ref="tabresearch" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TabSample from "./components/main/sample/index.vue";
import TabDesign from "./components/main/design/index.vue";
import TabResearch from "./components/main/research/index.vue";

export default {
  name: "personal-myFavorites",
  components: {
    TabSample,
    TabDesign,
    TabResearch,
  },
  data() {
    return {
      activeName: "sample",
    };
  },
};
</script>


<!--<template>
  <div class="card-form">
    <page-main
      ref="main"
      :sam-table-data="samTableData"
      :del-table-data="delTableData"
      :res-table-data="resTableData"
      :loading="loading"
      @submit="reload"
    />
    <js-pagination
      class="mt-2"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="sm"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  components: {
    PageMain: () => import('./components/main/index')
  },
  data() {
    return {
      isBusy: false,
      samTableData: [],
      delTableData: [],
      resTableData: [],
      loading: false,
      form: {
        productType: 'S'
      },
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
    }
  },
  created() {
    this.reload()
  },
  activated() {
    this.reload()
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.main.load()
      })
    },
    // 重载表格数据
    reload(form) {
      if (form) {
        this.form = form
      }
      this.handleSubmit(this.form)
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      if (form.productType === 'S') {
        this.$api
          .samListCollectApi({
            ...form,
            ...this.page
          })
          .then((res) => {
            this.loading = false
            this.page.pageTotal = res.body.count
            this.samTableData = res.body.data
          })
          .catch(() => {
            this.loading = false
          })
      } else if (form.productType === 'D') {
        this.$api
          .deListCollectApi({
            ...form,
            ...this.page
          })
          .then((res) => {
            this.loading = false
            this.page.pageTotal = res.body.count
            this.delTableData = res.body.data
          })
          .catch(() => {
            this.loading = false
          })
      } else if (form.productType === 'R') {
        this.$api
          .resListCollectApi({
            ...form,
            ...this.page
          })
          .then((res) => {
            this.loading = false
            this.page.pageTotal = res.body.count
            this.resTableData = res.body.data
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
<style lang="scss"></style>-->
